export class Mail{
    direccion:string;
    servidores:boolean[];
}
